import type { DesignSubmission } from "./design.js";
import type { ClientRoomState, ContentMode, GuessMap } from "./types.js";

/** Messages client → server. */
export type ClientMessage =
  | { type: "create_room"; name: string }
  | { type: "join_room"; code: string; name: string }
  | { type: "rejoin"; code: string; playerId: string }
  | { type: "set_content_mode"; contentMode: ContentMode }
  | { type: "start_game"; contentMode?: ContentMode }
  | { type: "submit_answer"; text: string }
  | { type: "submit_design"; design: DesignSubmission }
  | { type: "submit_guesses"; guesses: GuessMap }
  | { type: "vote_funniest"; answerId: string }
  | { type: "next_round" }
  | { type: "end_game" }
  | { type: "return_to_lobby" }
  | { type: "ping" };

/** Messages server → client. */
export type ServerMessage =
  | { type: "room_state"; state: ClientRoomState }
  | { type: "error"; code: ErrorCode; message: string }
  | { type: "pong" }
  | { type: "welcome"; playerId: string; code: string };

export type ErrorCode =
  | "invalid_payload"
  | "invalid_name"
  | "invalid_code"
  | "room_full"
  | "room_not_found"
  | "not_host"
  | "not_in_room"
  | "wrong_phase"
  | "already_submitted"
  | "not_enough_players"
  | "invalid_guesses"
  | "invalid_vote"
  | "internal";

export function parseClientMessage(raw: string): ClientMessage | null {
  try {
    const data = JSON.parse(raw) as unknown;
    if (!data || typeof data !== "object" || !("type" in data)) return null;
    return data as ClientMessage;
  } catch {
    return null;
  }
}

export function encodeMessage(msg: ClientMessage | ServerMessage): string {
  return JSON.stringify(msg);
}
